// vendor
import React from 'react';
import PropTypes from 'prop-types';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import { DateUtils } from 'react-day-picker';
import { Row, Col } from 'react-bootstrap';
import 'react-day-picker/lib/style.css';
import moment from 'moment';
import {
  formatDate,
  parseDate
} from 'react-day-picker/moment';

// app
import './style.scss';

class DateRangePicker extends React.Component {

  constructor(props) {
    super(props);
    this.handleDayClick = this.handleDayClick.bind(this);
    this.handleResetClick = this.handleResetClick.bind(this);
    this.state = this.getInitialState();
  }

  getInitialState() {
    return {
      from: undefined,
      to: undefined,
      inputValue: 'All dates'
    };
  }

  handleDayClick(day, modifiers) {
    let value = 'All dates';
    if (modifiers.disabled) {
      return;
    }

    const { handleSelectRange } = this.props;
    const range = DateUtils.addDayToRange(day, this.state);
    this.setState(range);

    const { from, to } = range;

    if (from && !to && this.el) value = `${moment(from).format('ll')} - Not Set`
    if (from && to) {
      value = `${moment(from).format('ll')} – ${moment(to).format('ll')}`
      if (handleSelectRange) {
        handleSelectRange(from, to)
      }
    }

    this.setState({ inputValue: value });
  }

  handleResetClick() {
    this.setState(this.getInitialState());
  }

  handleOnDayPickerHide = () => {
    const { from, to } = this.state;

    if (!from || !to) {
      this.clearSelectedRange();
    }
  }

  getInputValue = () => {
    const { from, to } = this.state;

    if (from && to) {
      return `${moment(from).format('ll')} – ${moment(to).format('ll')}`
    }

    return 'All dates';
  }

  clearSelectedRange = () => {
    const { handleSelectRange } = this.props;

    this.setState(this.getInitialState());

    handleSelectRange && handleSelectRange();
  }

  render() {
    const { from, to, inputValue } = this.state;
    const modifiers = { start: from, end: to };
    const {
      inputClassNames = '',
      inputPlaceholder,
      inputValue: inputPropsValue,
      minDate,
      maxDate,
      inputLabel,
      showClearButton
    } = this.props;

    const minDateWithOffset = new Date(minDate);
    const maxDateWithOffset = new Date(maxDate);

    const min = new Date(minDateWithOffset.getTime() - minDateWithOffset.getTimezoneOffset() * - 60000);
    const max = new Date(maxDateWithOffset.getTime() - maxDateWithOffset.getTimezoneOffset() * - 60000);

    const dayPickerProps = {
      className: 'Selectable',
      numberOfMonths: this.props.numberOfMonths,
      selectedDays: [from, { from, to }],
      onDayClick: this.handleDayClick,
      modifiers,
      month: min,
      fromMonth: min,
      toMonth: max,
      disabledDays: [{
        after: max,
        before: min
      }]
    };

    return (
      <Row>
        <Col md={12}>
          <div className="selected-week form-group">
            <div className="input-group-week-picker">
              <DayPickerInput
                ref={el => this.el = el}
                inputProps={{
                  className: `form-control ${!inputClassNames ? 'week-picker-input': ''} ${ typeof inputClassNames === 'Array' ? inputClassNames.join(' ') : inputClassNames}`,
                  readOnly: true
                }}
                formatDate={formatDate}
                parseDate={parseDate}
                value={inputPropsValue || inputValue}
                placeholder={inputPlaceholder}
                dayPickerProps={dayPickerProps}
                hideOnDayClick={false}
                onDayPickerHide={this.handleOnDayPickerHide}
                format="ll"
              />
              {showClearButton && (
                <span
                  className="clear-button"
                  onClick={this.clearSelectedRange}
                >
                  &times;
                </span>
              )}
            </div>
            <div className="input-description">{inputLabel}</div>
          </div>
        </Col>
      </Row>
    );
  }
}

DateRangePicker.defaultProps = {
  inputPlaceholder: 'All dates',
  inputLabel: 'See your courses only on a specific range',
  showClearButton: true,
  numberOfMonths: 1
}

DateRangePicker.propTypes = {
  inputClassNames: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  inputPlaceholder: PropTypes.string,
  inputValue: PropTypes.string,
  handleSelectRange: PropTypes.func,
  minDate: PropTypes.string,
  maxDate: PropTypes.string,
  inputLabel: PropTypes.string,
  showClearButton: PropTypes.bool,
  numberOfMonths: PropTypes.number
}

export default DateRangePicker;



// WEBPACK FOOTER //
// ./src/components/common/DatePicker/DateRangePicker.js